import { useState } from 'react';
import { checkConsent } from '../../../../../../api/consent';
import styles from './IdentifyStep.module.css';

function IdentifyStep({ onDone, onAddSelfConsent, onSkip }) {
  const [form, setForm] = useState({ name: '', birthDate: '', phone: '' });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [serverError, setServerError] = useState('');
  const [checkResult, setCheckResult] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let filtered = value;
    if (name === 'birthDate' || name === 'phone') {
      filtered = value.replace(/\D/g, '');
    }
    setForm(prev => ({ ...prev, [name]: filtered }));
    setErrors(prev => ({ ...prev, [name]: '' }));
    setCheckResult(null);
  };

  const validate = () => {
    const errs = {};
    if (!form.name.trim() || form.name.trim().length < 2) {
      errs.name = '이름을 2자 이상 입력해 주세요.';
    }
    if (!/^\d{8}$/.test(form.birthDate)) {
      errs.birthDate = '생년월일 8자리를 입력해 주세요. (예: 19500101)';
    }
    if (!/^010\d{8}$/.test(form.phone)) {
      errs.phone = '010으로 시작하는 휴대폰번호를 입력해 주세요.';
    }
    return errs;
  };

  const handleSubmit = async () => {
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }
    setIsLoading(true);
    setServerError('');
    try {
      const result = await checkConsent({ name: form.name.trim(), birthDate: form.birthDate, phone: form.phone });
      if (result.hasGuardianConsent && !result.hasSelfConsent) {
        setCheckResult(result);
      } else {
        onDone(result, { name: form.name.trim(), birthDate: form.birthDate, phone: form.phone });
      }
    } catch (err) {
      setServerError(err.message || '오류가 발생했습니다. 다시 시도해 주세요.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.wrap}>
      <p className={styles.title}>어르신 정보 입력</p>
      <div className={styles.fieldGroup}>
        <div>
          <label className={styles.label}>성명</label>
          <input
            className={styles.input}
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="어르신 성명"
            maxLength={20}
          />
          {errors.name && <p className={styles.errorMsg}>{errors.name}</p>}
        </div>
        <div>
          <label className={styles.label}>생년월일 (8자리)</label>
          <input
            className={styles.input}
            name="birthDate"
            value={form.birthDate}
            onChange={handleChange}
            placeholder="예) 19500101"
            maxLength={8}
            inputMode="numeric"
          />
          {errors.birthDate && <p className={styles.errorMsg}>{errors.birthDate}</p>}
        </div>
        <div>
          <label className={styles.label}>휴대폰번호</label>
          <input
            className={styles.input}
            name="phone"
            value={form.phone}
            onChange={handleChange}
            placeholder="예) 01012345678"
            maxLength={11}
            inputMode="numeric"
          />
          {errors.phone && <p className={styles.errorMsg}>{errors.phone}</p>}
        </div>
      </div>
      {serverError && <p className={styles.errorMsg}>{serverError}</p>}
      {!checkResult && (
        <button className={styles.submitBtn} onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? '확인 중...' : '확인'}
        </button>
      )}
      {checkResult && checkResult.hasGuardianConsent && !checkResult.hasSelfConsent && (
        <div className={styles.inlineResult}>
          <p className={styles.inlineMsg}>
            보호자 대리동의가 완료되어 있습니다.<br />
            어르신 본인 동의를 추가로 진행하시겠습니까?
          </p>
          <div className={styles.inlineBtns}>
            <button
              className={styles.addConsentBtn}
              onClick={() => onAddSelfConsent(
                { name: form.name.trim(), birthDate: form.birthDate, phone: form.phone },
                checkResult.seniorId
              )}
            >
              본인 동의 추가
            </button>
            <button className={styles.skipBtn} onClick={onSkip}>건너뜀</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default IdentifyStep;
